/**
 * "You are seeing the most recent N" (#372).
 *
 * Raised from a device question: does the activity feed become a
 * scrolling window at some length, or grow forever?
 *
 * It was always bounded and nothing said so, which left a reader who
 * scrolled to the end unable to tell whether that was ALL THERE IS or
 * ALL THEY ARE BEING SHOWN. Those are different facts about their own
 * records, and only one of them means "keep looking somewhere else".
 *
 * RENDERS NOTHING UNTIL THE LIST IS ACTUALLY FULL. The server returns
 * capped_at only when it had to leave rows behind -- it asks for one row
 * more than the cap to find out -- so this never appears on a short list
 * and never becomes furniture somebody stops reading.
 *
 * AT THE BOTTOM, where the question is asked. A banner above a list
 * answers a question nobody has had yet; this is read at the moment
 * somebody reaches the end and wonders.
 *
 * SAYS WHAT TO DO ABOUT IT, where there is anything to do. A notice that
 * only reports a limit is a dead end, and #372's complaint was precisely
 * that row 201 was unreachable -- so a list with filters says so, because
 * narrowing is how you reach what the cap hid.
 */
export function ListBound({ cappedAt, noun = "entries", filterable = false }) {
  if (!cappedAt) return null;

  return (
    <p
      role="status"
      style={{
        margin: "var(--space-3) 0 0",
        color: "var(--color-text-muted)",
        fontSize: "var(--font-size-sm)",
        textAlign: "center",
      }}
    >
      Showing the most recent {cappedAt} {noun}.
      {filterable && " Narrow the dates or the person to see further back."}
    </p>
  );
}
